import { convertMinorAmountToMajor } from '@/legacy/store/helpFunctions'
import { normalizeImage } from '@/lib/adapters/image.adapters'
import type { Link, LinkListFilter, LinkRaw, LinkStatsParams } from '@/lib/types/links.types'

const computeRoas = (orderValue: number, cost: number): number => {
  if (!cost) {
    return 0
  }
  return orderValue / cost
}

export const normalizeLink = (raw: LinkRaw): Link => {
  const cost = convertMinorAmountToMajor(raw.cost)
  const orderValue = convertMinorAmountToMajor(raw.order_value)

  return {
    tagId: raw.tag_id,
    userId: raw.user_id,
    username: raw.username,
    link: raw.link,
    originalUrl: raw.original_url,
    title: raw.title,
    image: raw.image ? normalizeImage(raw.image) : undefined,
    createdAt: raw.created_at,
    clicks: Number(raw.clicks),
    nrOfOrders: Number(raw.nr_orders),
    orderValue,
    cost,
    costPerClick: convertMinorAmountToMajor(raw.cost_per_click),
    mtpcUrl: raw.mtpc_url,
    roas: computeRoas(orderValue, cost),
    trafficSourceCode: raw.traffic_source_code,
  }
}

export const normalizeLinks = (rawList: LinkRaw[]): Link[] => rawList.map(normalizeLink)

export const handleLinksFilter = (filter: LinkListFilter, userIds: number[]): LinkStatsParams => ({
  ...(filter.dateFrom && filter.dateTo && { from: filter.dateFrom, to: filter.dateTo }),
  orderBy: filter.sortBy,
  orderByOrder: filter.sortOrder,
  ...(filter.query && { query: filter.query }),
  ...(userIds.length && { users: userIds.join(',') }),
  ...(filter.trafficSourceCode && { traffic_source_code: filter.trafficSourceCode }),
  page: filter.page,
})
